import { Component, Input, ViewChild, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';

import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'jt-modal',
  templateUrl: './jt-modal.component.html',
  styleUrls: ['./jt-modal.component.css'],
  standalone: true,
  imports: [ModalModule, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class JtModalComponent {
  /** The translation key for the modal title */
  @Input({ required: true }) title!: string;
  
  /** The size of the modal */
  @Input() size: 'sm' | 'md' | 'lg' | 'xl' = 'md';
  
  /** Whether to show the close cross in the top right */
  @Input() showClose: boolean = true;
  
  /** Whether the modal has a footer section projected */
  @Input() hasFooter: boolean = true;
  
  /** ngx-bootstrap modal configuration */
  @Input() config: any = { backdrop: 'static', keyboard: false };

  /** Unique ID for aria-labelledby association */
  public titleId: string = `jt-modal-title-${Math.random().toString(36).substr(2, 9)}`;

  /** Emitted when modal is about to show */
  @Output() byShow = new EventEmitter<any>();
  /** Emitted when modal has completely shown and animation finished */
  @Output() byShown = new EventEmitter<any>();
  /** Emitted when modal is about to hide */
  @Output() byHide = new EventEmitter<any>();
  /** Emitted when modal has completely hidden and animation finished */
  @Output() byHidden = new EventEmitter<any>();

  @ViewChild('bsModalInstance', { static: true }) bsModalInstance!: ModalDirective;

  /** Shows the modal */
  show(): void {
    this.bsModalInstance.show();
  }

  /** Hides the modal */
  hide(): void {
    this.bsModalInstance.hide();
  }
}
